import { useCallback, useState } from "react";
import GROUPS_CONSTANTS, { CUSTOMERS_PAGE_CONSTANTS } from "../Customers.constants";

const existsCheckFailedMessage =
  CUSTOMERS_PAGE_CONSTANTS.customerExistsValidationFailedError;

const nameExistsFallback =
  GROUPS_CONSTANTS.createGroupErrorMessages.name;
const codeExistsFallback =
  GROUPS_CONSTANTS.createGroupErrorMessages.idDuplicate.replace(
    "{idType}",
    "Customer ID"
  );

async function runExistsCheck(checkCustomerExists, params, setChecking) {
  if (typeof checkCustomerExists !== "function") {
    return { exists: false, field: null, fieldError: null };
  }

  setChecking(true);
  try {
    const result = await checkCustomerExists(params);
    if (result?.error) {
      return {
        exists: false,
        field: null,
        fieldError: existsCheckFailedMessage,
        validationFailed: true,
      };
    }
    const exists = Boolean(result?.data?.exists);
    const apiMessage =
      typeof result?.data?.message === "string"
        ? result.data.message.trim()
        : "";
    const fallback =
      params.name != null && String(params.name).trim() !== ""
        ? nameExistsFallback
        : codeExistsFallback;
    return {
      exists,
      field: result?.data?.field ?? null,
      fieldError: exists ? apiMessage || fallback : null,
    };
  } finally {
    setChecking(false);
  }
}

export function useCustomerExistsCheck({ checkCustomerExists } = {}) {
  const [checkingName, setCheckingName] = useState(false);
  const [checkingCode, setCheckingCode] = useState(false);

  const checkNameOnBlur = useCallback(
    async (name) => {
      const trimmed = String(name ?? "").trim();
      if (!trimmed) {
        return { exists: false, field: null, fieldError: null };
      }
      return runExistsCheck(
        checkCustomerExists,
        { name: trimmed },
        setCheckingName
      );
    },
    [checkCustomerExists]
  );

  const checkCodeOnBlur = useCallback(
    async (code) => {
      const trimmed = String(code ?? "").trim();
      if (!trimmed) {
        return { exists: false, field: null, fieldError: null };
      }
      return runExistsCheck(
        checkCustomerExists,
        { code: trimmed },
        setCheckingCode
      );
    },
    [checkCustomerExists]
  );

  return {
    checkingName,
    checkingCode,
    checkNameOnBlur,
    checkCodeOnBlur,
  };
}
